// extracted by mini-css-extract-plugin
export var actionButton = "_mt-t";
export var buttonContainer = "_mt-0";
export var buttonContainer2 = "_mt-1";
export var buttonSection = "_mt-2";
export var details = "_mt-3";
export var dropdownItem = "_mt-5";
export var dropdownItemsContainer = "_mt-4";
export var fileInput = "_mt-r";
export var headerButton = "_mt-6";
export var icon = "_mt-7";
export var input = "_mt-8";
export var macroListItem = "_mt-9";
export var mainContent = "_mt-a";
export var microText = "_mt-b";
export var modal = "_mt-w";
export var optionsButton = "_mt-c";
export var paperclip = "_mt-s";
export var pillContent = "_mt-d";
export var preview = "_mt-e";
export var preview2 = "_mt-f";
export var quillEditor = "_mt-q";
export var selectedMacro = "_mt-g";
export var sidebar = "_mt-h";
export var sidebarHeader = "_mt-j";
export var sidebarList = "_mt-i";
export var sidebarListItem = "_mt-k";
export var sidebarSearch = "_mt-l";
export var snoozeDurationWrapper = "_mt-v";
export var statusPillContainer = "_mt-m";
export var tagsContainer = "_mt-n";
export var unselectedMacro = "_mt-o";
export var variable = "_mt-u";
export var wrapper = "_mt-p";